
import Home from '../home/Home';
import About from '../about/About';
import Resume from '../resume/Resume';
import Skills from '../skills/Skills';
import Portfolio from '../portfolio/Portfolio';
import Contact from '../contact/Contact';
import Lines from "../ui/lines/Lines";
import Footer from "../../components/ui/Footer/Footer";

function App() {
  return (
    <div className='relative overflow-hidden'>
        <Lines/>
       <Home />
        <About />
        <Resume />
        <Skills />
        <Portfolio />
        <Contact />
        <Footer/>
    </div>
  );
}

export default App;
